import { Grid, TextField } from "@mui/material";
import Field from "components/Field";
import { MediaLibraryImageSelector } from "components/MediaLibraryImageSelector";
import { MetaValueFieldProps } from "pages/AttributesPage/CustomAttributeComponents/metaValueComponents";

export function MediaLibraryImageField({
  metaValueName,
  index,
  attributeMetaValues,
}: MetaValueFieldProps) {
  const existingValue = attributeMetaValues?.find(
    (m) => m.name === metaValueName,
  )?.value;

  return (
    <>
      <Field
        name={`attributeMetaValues[${index}].name`}
        initialValue={metaValueName}
      >
        {() => null}
      </Field>
      <Field
        name={`attributeMetaValues[${index}].value`}
        initialValue={existingValue ?? ""}
      >
        {({ input }) => (
          <Grid item xs={12} sx={{ mb: 2 }}>
            <MediaLibraryImageSelector
              value={input.value || undefined}
              onChange={(id) => input.onChange(id ?? "")}
            />
          </Grid>
        )}
      </Field>
    </>
  );
}
